<template>
  <div class="d-flex align-center">
    <v-text-field
      @keydown.enter.prevent="submit"
      :label="$t('journal.search.filters.time.input')"
      type="number"
      v-model="daysAgo"
      hide-details
      dense
      outlined
      :rules="rules"
    />
    <v-switch
      v-model="include"
      class="ml-2"
      style="width: 150px; max-width: 150px;"
      :label="include
        ? $t('journal.search.filters.included')
        : $t('journal.search.filters.excluded')"
    />
  </div>
</template>
<script>
import { nanoid } from 'nanoid';
import { criterias } from '../SearchCriteria';

export default {
  name: 'DateFilter',
  props: {
    params: {
      type: Object,
      default: undefined,
    },
  },
  data: () => ({
    daysAgo: 30,
    include: true,
    id: `${criterias.TIME_WINDOW_FILTER}/${nanoid(10)}`,
    rules: [
      v => !!v || 'Ce champs ne peut être vide',
    ],
  }),
  created() {
    if (this.params !== undefined) {
      const data = this.params.filters[0].Time;
      this.id = data.id;
      this.include = data.kind === 'Include';
      this.daysAgo = data.param.from.amount;
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    },
    getCriteria() {
      return {
        filters: [
          {
            Time: {
              kind: this.include ? 'Include' : 'Exclude',
              param: {
                from: {
                  time: Number.parseInt(this.daysAgo, 10),
                  unit: 'days',
                },
                to: {
                  time: 0,
                  unit: 'ms',
                },
              },
              id: this.id,
            },
          },
        ],
      };
    },
  },
};
</script>
